let isMsTeamsEnv = false;

export const setIsMsTeamsEnv = (value: boolean) => {
  isMsTeamsEnv = value;
};

export const getIsMsTeamsEnv = () => isMsTeamsEnv;
